
import { Routes, Route } from 'react-router-dom';
import './App.css';
import MainLayout from './layouts/MainLayout';
import PlainLayout from './layouts/PlainLayout';
import Hero from './components/Hero';
import AboutMe from './pages/AboutMe';
import HowICanHelp from './pages/HowICanHelp';
import Pricing from './pages/Pricing';
import Certifications from './pages/Certifications';
import Testimonials from './pages/Testimonials';
import NewsAndEvents from './pages/NewsAndEvents';
import TermsPrivacy from './pages/TermsPrivacy';
import Payment from './pages/Payment';
import RPSwiss from './rpswiss/RPSwiss';

function App() {

  return (
    <Routes>
      {/* Pages WITH layout */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Hero />} />
        <Route path="/about-me" element={<AboutMe />} />
        <Route path="/how-i-can-help" element={<HowICanHelp />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/certifications" element={<Certifications />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/news-and-events" element={<NewsAndEvents />} />
        <Route path="/terms-and-privacy" element={<TermsPrivacy />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/success" element={<Payment result="success" />} />
        <Route path="/cancel" element={<Payment result="cancel" />} />
      </Route>

      {/* Pages WITHOUT layout */}
      <Route element={<PlainLayout />}>
        <Route path="/rpswiss" element={<RPSwiss />} />
      </Route>
    </Routes>
  );
}

export default App;
